import { render, staticRenderFns } from "./BusinessObjAttr.vue?vue&type=template&id=ea4377e4&scoped=true&"
import script from "./BusinessObjAttr.vue?vue&type=script&lang=js&"
export * from "./BusinessObjAttr.vue?vue&type=script&lang=js&"
import style0 from "./BusinessObjAttr.vue?vue&type=style&index=0&id=ea4377e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4377e4",
  null
  
)

export default component.exports